import React from 'react';

export const EmptyTable = <h4 className="text-center mt-4 mb-4">Il n'y a pas de données disponibles à ce moment.</h4>;